import { useI18n } from '@change-corgi/core/react/i18n';

import { usePromotePageData } from 'src/app/pages/promote/pageContext';

export type PpmuLocalizedHeadlineData = {
	totalSignatureCount: number;
	userCountryName: string;
};

export function useFetchLocalizedPPMUHeadlineData(): PpmuLocalizedHeadlineData | undefined {
	const {
		data: { user, countryOrStateSignatureCounts },
	} = usePromotePageData();
	const { getCountry } = useI18n();

	const {
		country: { countryCode: userCountryCode },
	} = user;

	// Validate essential data
	if (!userCountryCode || !countryOrStateSignatureCounts?.totalSignatureCount) {
		return undefined;
	}

	const { totalSignatureCount } = countryOrStateSignatureCounts;
	// If total signature count is less than or equal to 1, we don't show the headline
	if (totalSignatureCount <= 1) {
		return undefined;
	}

	const userCountryData = getCountry(userCountryCode);
	if (!userCountryData) {
		return undefined;
	}

	return {
		totalSignatureCount,
		userCountryName: userCountryData.name,
	};
}
